module.exports = __webpack_public_path__ + "media/images/close-e9978ac9d2f718865b07ba99a8159ffc.svg";